var verifyCallback;


$(function () {

    'use strict';


    var myForm = $('form#contactForm'),
        submitBtn = $('#form_submit_btn'),
        captchaVal = $('#recaptcha'),
        dismissBtn = $('#msg_dismiss'),
        showbox = $('#showbox'),
        loading = $('#loading'),
        contactObj = {
            beforeSend: function () {
                submitBtn.prop('disabled', true)
                loading.removeClass('hidden')
                showbox.addClass('show')

            },
            dataComplete: function (resp) {
                var msgPanel = showbox.find('#message_' + (resp.status && resp.status > 0 ? 'success' : 'error'))
                msgPanel.length ? msgPanel.removeClass('hidden') : ''

            },
            always: function () {
                loading.addClass('hidden')

            }
        }

    verifyCallback = function (res) {
        var valid = res != '' || res != undefined || res.length != 0;
        captchaVal.val(valid ? 'OK' : '');
    };

    $.validator.setDefaults({
        submitHandler: function (form) {
            contactObj.data = $('#'+myForm.attr('id')).serialize()
            if ($(form).valid()) {
                // form.submit();
                CallPage(contactObj);
            }

            return false; // prevent normal form posting
        },
        ignore: '',

        highlight: function (elm) {
            elmHighlight($(elm));
            // $(element).closest('.form-group').addClass('has-error');
        },

        success: function (elm) {
            elmUnHighlight($(elm));
            // $(element).closest('.form-group').removeClass('has-error');
        },

        errorElement: 'span',

        errorClass: 'help-block',

        errorPlacement: function (error, elm) {
            elmPlacement(error, elm);
            // if (element.parent('.input-group').length) {
            //     error.insertAfter(element.parent());
            // } else {
            //     error.insertAfter(element);
            // }
        }

    });

    function elmHighlight(elm) {
        return elm.closest('.form-group').addClass('has-error');
    }

    function elmUnHighlight(elm) {
        return elm.closest('.form-group').removeClass('has-error');
    }

    function elmPlacement(error, elm) {
        if (elm.parent('.input-group').length) {
            error.insertAfter(elm.parent());
        } else {
            error.insertAfter(elm);
        }
    }


    dismissBtn.on('click', function () {
        grecaptcha.reset();
        // grecaptcha.reset(".g-recaptcha", myForm);
        $('#'+myForm.attr('id'))[0].reset();
        submitBtn.prop('disabled', false)
        showbox.removeClass('show');
        $('.msg-box').addClass('hidden')
    });

    myForm.validate();

    /*    submitBtn.on('click', function () {
    // console.log(myForm.valid())
            if (myForm.valid()) {
                alert('yeap')
                myForm.submit();
            }


        });*/


});